import { render, staticRenderFns } from "./GoogleDriveUrlButton.vue?vue&type=template&id=f2d07a1e"
import script from "./GoogleDriveUrlButton.vue?vue&type=script&lang=js"
export * from "./GoogleDriveUrlButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports